// Workspace-specific sync wire schemas.
// The doc schema is derived from the Drizzle table via `wireFromDrizzle`
// (the table is the single source of truth for shape; the helper applies
// Date→ISO and soft-delete→`_deleted` tombstone conventions).
// Envelope schemas (pull/push in+out) are built from the generic factories
// in `schemas.ts`.

import { workspaces } from '../../../drizzle/v2Schema';
import { wireFromDrizzle } from './lib/wireFromDrizzle';
import {
  makePullInput,
  makePullOutput,
  makePushInput,
  makePushOutput,
  syncPositionSchema,
  syncTitleSchema,
  syncUlidSchema,
  syncUserIdSchema,
} from './schemas';
import { type z } from 'zod/v4';

// ─── Doc schema ─────────────────────────────────────────────

export const workspaceDocSchema = wireFromDrizzle(workspaces, {
  overrides: {
    id: () => syncUlidSchema,
    position: () => syncPositionSchema,
    title: () => syncTitleSchema,
    userId: () => syncUserIdSchema,
  },
  softDelete: 'deletedAt',
});

export type WorkspaceDocWire = z.infer<typeof workspaceDocSchema>;

// ─── Envelopes ───────────────────────────────────────────────

export const workspacesPullInput = makePullInput();
export const workspacesPullOutput = makePullOutput(workspaceDocSchema);
export const workspacesPushInput = makePushInput(workspaceDocSchema);
export const workspacesPushOutput = makePushOutput(workspaceDocSchema);

export type WorkspacesPullInput = z.infer<typeof workspacesPullInput>;
export type WorkspacesPullOutput = z.infer<typeof workspacesPullOutput>;
export type WorkspacesPushInput = z.infer<typeof workspacesPushInput>;
export type WorkspacesPushOutput = z.infer<typeof workspacesPushOutput>;
export type WorkspacesPushRow = z.infer<
  typeof workspacesPushInput
>['rows'][number];
